/* eslint no-param-reassign: "off" */
import * as types from './mutation-types';

export default {
  [types.GET_SINGLE_USE_TOKEN_REQUEST]: state => {
    state.loadingSingleUseToken = true;
    state.loadingSingleUseTokenSuccess = false;
    state.loadingSingleUseTokenFailed = false;
  },
  [types.GET_SINGLE_USE_TOKEN_FAILURE]: (state, error) => {
    state.loadingSingleUseToken = false;
    state.loadingSingleUseTokenSuccess = false;
    state.loadingSingleUseTokenFailed = true;
    state.loadingSingleUseTokenError = error;
  },
  [types.GET_SINGLE_USE_TOKEN_SUCCESS]: (state, response) => {
    state.loadingSingleUseToken = false;
    state.loadingSingleUseTokenSuccess = true;
    state.loadingSingleUseTokenFailed = false;
    state.singleUseToken = response.token;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/tokens/mutations.js